import React, {useState} from 'react';
import {LoadingButton} from '@mui/lab';
import {Button, Menu, MenuItem, Stack, useTheme} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const ExportAsSelector = ({exportAsExcel, exportAsPDF, disabled, loading, ...props}: any) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (action: any) => {
    action();
    handleClose();
  };

  const predifinedOptions = [
    {label: 'Export as Excel', action: exportAsExcel},
    {label: 'Export as PDF', action: exportAsPDF}
  ];

  return (
    <Stack direction="row" alignItems="center">
      {/* Default Export Button */}
      <LoadingButton
        type="submit"
        variant="outlined"
        onClick={() => handleMenuItemClick(predifinedOptions[0].action)}
        loading={loading}
        disabled={disabled}
        sx={{
          bgcolor: theme.palette.info.darker,
          borderTopRightRadius: 'inherit !important',
          borderBottomRightRadius: 'inherit !important',
          color: 'white',
          '&:hover': {bgcolor: theme.palette.info.dark}
        }}>
        Export
      </LoadingButton>

      {/* Dropdown Button */}
      {predifinedOptions.length > 1 && (
        <>
          <Button
            disabled={disabled || loading}
            sx={{
              bgcolor: theme.palette.info.darker,
              color: 'white',
              borderTopLeftRadius: 'inherit !important',
              borderBottomLeftRadius: 'inherit !important',
              minWidth: '10px',
              maxWidth: '10px',
              '&:hover': {bgcolor: theme.palette.info.dark}
            }}
            aria-controls={open ? 'export-as-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-haspopup="menu"
            onClick={handleClick}>
            <ArrowDropDownIcon />
          </Button>

          {/* Dropdown Menu */}
          <Menu
            id="export-as-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}>
            {predifinedOptions.map(option => (
              <MenuItem
                key={option.label}
                onClick={() => handleMenuItemClick(option.action)}>
                {option.label}
              </MenuItem>
            ))}
          </Menu>
        </>
      )}
    </Stack>
  );
};

export default ExportAsSelector;
